























import { Component, Vue, Prop, Model, Watch } from "vue-property-decorator";

/**
 * A roster selector component.
 */
@Component
export default class RosterSelector extends Vue {
	/// Injections

	/// Properties
	@Prop()
	rosters!: any[] | null;

	@Prop()
	isLoading!: boolean;


	/// Attributes


	get canSetPreviousRoster() {
		if (!this.rosters) {
			return false;
		}
		return this.rosters.findIndex(x => x.id == this.activeRosterId) > 0;
	}

	get canSetNextRoster() {
		if (!this.rosters) {
			return false;
		}
		return this.rosters.findIndex(x => x.id == this.activeRosterId) < this.rosters.length - 1;
	}

	/** V-MODEL */
	@Model("change", {type: String})
	readonly externalModel!: string | null;

	activeRosterId: string | null = null;

	@Watch("activeRosterId")
	onInternalModelChanged(val: string) {
		this.$emit("change", val);
	}

	@Watch("externalModel")
	onExternalModelChanged(val: string) {
		this.activeRosterId = val;
	}

	created() {
		this.activeRosterId = this.externalModel;
	}

	handleSetPreviousRoster() {
		if (!this.rosters) {
			return;
		}
		const currentRosterIndex = this.rosters.findIndex(x => x.id == this.activeRosterId);
		this.activeRosterId = this.rosters[(currentRosterIndex - 1 + this.rosters.length) % this.rosters.length].id;
	}

	handleSetNextRoster() {
		if (!this.rosters) {
			return;
		}
		const currentRosterIndex = this.rosters.findIndex(x => x.id == this.activeRosterId);
		this.activeRosterId = this.rosters[(currentRosterIndex + 1 + this.rosters.length) % this.rosters.length].id;
	}
}
